import { render, staticRenderFns } from "./production.vue?vue&type=template&id=043a5130&"
import script from "./production.vue?vue&type=script&lang=js&"
export * from "./production.vue?vue&type=script&lang=js&"
import style0 from "./production.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports